import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const messageRecipientSchemaLiteral = {
  title: 'Message Recipient Schema',
  description: 'Describes a message recipient',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    email: {
      type: 'string',
    },
    firstName: {
      ref: 'packs',
      type: 'string',
    },
    lastName: {
      type: 'string',
    },
    company: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'email', 'firstName', 'lastName'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(messageRecipientSchemaLiteral)

export type MessageRecipientDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const messageRecipientSchema: RxJsonSchema<MessageRecipientDocType> = schemaTyped

export type MessageRecipientDocMethods = {
  getFullName: () => string
}

export const messageRecipientDocMethods = {
  getFullName() {
    return `${this.firstName} ${this.lastName}`
  },
}

export type MessageRecipientDocument = RxDocument<MessageRecipientDocType, MessageRecipientDocMethods>

export type MessageRecipientCollectionMethods = {
  test: () => void
}

export type MessageRecipientCollection = RxCollection<
  MessageRecipientDocType,
  MessageRecipientDocMethods,
  MessageRecipientCollectionMethods
>
